import React, { useState, useRef, useEffect } from "react";
import { BiCaretDown } from "react-icons/bi";

const SingleSelectbox = ({
  options,
  selectedValue,
  onChange,
  placeholder,
  disabled = false,
  style = {} // Nhận prop style
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectBoxRef = useRef(null);

  const toggleDropdown = () => {
    if (!disabled) {
      setIsOpen(!isOpen);
    }
  };

  const handleOptionClick = (option) => {
    if (!disabled) {
      onChange(option);
      setIsOpen(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        selectBoxRef.current &&
        !selectBoxRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="selectbox" ref={selectBoxRef}>
      <style>
        {`
          .selectbox {
            position: relative;
            width: 100%; 
            cursor: ${
              disabled ? "not-allowed" : "pointer"
            }; /* Change cursor if disabled */
          }

          .selectbox__selected {
            padding: 8px;
            border: 1px solid #ccc; /* Keep border color same */
            background-color: #fff; /* Keep background color same */
            color: #000; /* Keep text color same */
            border-radius: 8px;
            transition: border-color 0.2s;
            display: flex; /* Use flexbox for alignment */
            align-items: center; /* Center icon and label vertically */
            justify-content: space-between; /* Space between icon and label */
            opacity: ${disabled ? "1" : "1"}; /* Keep opacity same */
            ...style /* Áp dụng style vào phần tử .selectbox__selected */
          }

          .selectbox__selected:hover {
            border-color: ${
              disabled ? "#ccc" : "#888"
            }; /* Change border color on hover only if not disabled */
          }

          .selectbox__options {
            position: absolute;
            top: 100%;
            left: 0;
            right: 0;
            border: 1px solid #ccc;
            background-color: #fff;
            border-radius: 4px;
            z-index: 1000;
            max-height: 200px; /* Limit dropdown height */
            overflow-y: auto; /* Add scroll if content exceeds height */
          }

          .selectbox__option {
            padding: 10px;
            transition: background-color 0.2s;
            display: flex; /* Use flexbox for alignment */
            align-items: center; /* Center icon and label vertically */
          }

          .selectbox__option:hover {
            background-color: #f0f0f0; /* Background color on hover */
          }

          .selectbox__icon {
            width: 20px; /* Fixed width for icons */
            height: 20px; /* Fixed height for icons */
            margin-right: 8px; /* Space between icon and label */
          }

          .selectbox__caret {
            transition: transform 0.2s; /* Add transition for caret icon */
            margin-left: 8px; /* Space between label and caret icon */
          }

          .selectbox__caret.rotate {
            transform: rotate(180deg); /* Rotate icon 180 degrees */
          }

          .selectbox__content {
            display: flex; /* Use flexbox for alignment */
            align-items: center; /* Center icon and label vertically */
            flex-grow: 1; /* Allow this part to take remaining space */
          }
        `}
      </style>
      <div
        className="selectbox__selected"
        onClick={toggleDropdown}
        style={style}
      >
        {" "}
        {/* Áp dụng style ở đây */}
        <div className="selectbox__content">
          {selectedValue && selectedValue.icon && (
            <img src={selectedValue.icon} alt="" className="selectbox__icon" />
          )}
          {selectedValue ? selectedValue.label : placeholder}
        </div>
        <img
          src="/icon/Caret_Down_MD.svg"
          alt="caret down"
          className={`selectbox__caret ${isOpen ? "rotate" : ""}`}
        />
      </div>
      {isOpen && (
        <div className="selectbox__options">
          {options.map((option) => (
            <div
              key={option.value}
              className="selectbox__option"
              onClick={() => handleOptionClick(option)}
            >
              {option.icon && (
                <img src={option.icon} alt="" className="selectbox__icon" />
              )}
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SingleSelectbox;
